export default __webpack_public_path__ + "static/media/verkada.9e9acf84.svg";